export const slotGamesDevelopmentTextContent = {
  headingText: "Why GammaStack’s Slot Games Development?",
  btnText: "Hire Slot Games Developers",
  content: [
    {
      iconSrc: "/assets/stock-img/slot_games_development_img_01.webp",
      titleText: "100% Ownership",
      paraText: "Fully own your online slot game software for complete control and management aids.",
    },
    {
      iconSrc: "/assets/stock-img/slot_games_development_img_02.webp",
      titleText: "No GGR Share",
      paraText: "As a slot game development company, we offer clients with no revenue share benefits for their 100% profitability. ",
    },
    {
      iconSrc: "/assets/stock-img/slot_games_development_img_03.webp",
      titleText: "Comprehensive Development",
      paraText: "Complete assistance from pre-launch, launch, and post-launch timelines for seamless split game development.",
    },
    {
      iconSrc: "/assets/stock-img/slot_games_development_img_04.webp",
      titleText: "24/7 Assistance",
      paraText: "Round-the-clock user and operator support for a hassle-free gaming experience.",
    },
    {
      iconSrc: "/assets/stock-img/slot_games_development_img_05.webp",
      titleText: "Hire Artists & Experts",
      paraText: "Hire slot game designers and developers for tailored slot game software development.",
    },
    {
      iconSrc: "/assets/stock-img/slot_games_development_img_06.webp",
      titleText: "Special Designs/UI/UX",
      paraText: "Make your slot game brand-specific using bespoke designs, UI/UX, and animation benefits.",
    },
  ],
};
